import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { X, Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { safeGetItem, safeSetItem } from "@/lib/safe-storage";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const hasConsentChoice = safeGetItem('cookie-consent');
    if (!hasConsentChoice) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    safeSetItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    safeSetItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-md">
      <Card className="obsidian-glass border-primary/20">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <Cookie className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
            <div className="flex-1 space-y-3">
              <div>
                <h3 className="font-semibold text-sm mb-1">We use cookies</h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  We use essential cookies to keep you signed in and functional cookies to improve your experience. 
                  See our{" "}
                  <Link to="/cookie-policy" className="text-primary hover:underline">
                    Cookie Policy
                  </Link>{" "}
                  for details.
                </p>
              </div>
              <div className="flex gap-2">
                <Button 
                  size="sm" 
                  className="energy-button text-xs px-3 py-1.5 h-auto"
                  onClick={handleAccept}
                >
                  Accept
                </Button>
                <Button 
                  size="sm" 
                  variant="outline" 
                  className="text-xs px-3 py-1.5 h-auto"
                  onClick={handleDecline}
                >
                  Decline
                </Button>
              </div>
            </div>
            <Button
              size="sm"
              variant="ghost"
              className="w-6 h-6 p-0 hover:bg-muted"
              onClick={() => setIsVisible(false)}
            >
              <X className="w-3 h-3" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CookieConsent;